export enum StatusEnums {
  pending = 0,
  inShelf = 1,
  delivered = 2,
};

export type SearchHubCardProps = {
  order: {
    customer_name: string;
    order_number: number;
    vendor_name: string;
    shelf_number: number;
    status: number;
  };
  showModalWithNum: (input: object) => void;
};